// © Microsoft Corporation. All rights reserved.

import { TelemetryBehaviorType, TelemetryContentType, TelemetryObjectBase } from "@msnews/telemetry-contracts";
import { TelemetryEventMap, dispatchTelemetryEvent, genericTelemetryClickDispatcher } from "../../Social.telemetry";

export interface ReactionPanelTelemetryObjects {
    likeButton: TelemetryObjectBase;
    activeReactionButton: TelemetryObjectBase;
}

export const reactionPanelTelemetryContracts = {
    likeButton: { // Scenario 2 click, Scenario 2a hover
        name: "Reaction",
        behavior: TelemetryBehaviorType.Like, // dynamically updated
        content: {
            type: TelemetryContentType.Comment,
            headline: "Like" // dynamically updated
        }
    }
};

export const reactionPanelTelemetryActionDispatchers = {
    likeButtonClick: genericTelemetryClickDispatcher,
    likeButtonHover: (element: any, telemetryObject: any): void => {
        const telemetryEventDispatcherInfo = {
            ...TelemetryEventMap.genericHover,
            contract: {...(telemetryObject && telemetryObject.contract)}
        };

        dispatchTelemetryEvent(telemetryEventDispatcherInfo, element);
    }
};